<template>
  <div>
    <main-container>
      <car-picker slot="carPicker"></car-picker>
      <map-dealer slot="dealerMap" v-if="!dws"></map-dealer>
      <user-detail slot="userDetail" v-if="$store.state.form.car.model && $store.state.form.dealer"></user-detail>
      <submit-btn slot="submitBtn" v-if="$store.state.form.car.model && $store.state.form.dealer"></submit-btn>
    </main-container>
  </div>
</template>

<script>
import MapDealer from '@/components/form/MapDealer'
import CarPicker from '@/components/form/CarPicker'
import MainContainer from '@/components/form/MainContainer'
import UserDetail from '@/components/form/UserDetail'
import SubmitBtn from '@/components/form/SubmitBtn'
export default {
  name: 'Form',
  components: {
    MapDealer,
    CarPicker,
    MainContainer,
    UserDetail,
    SubmitBtn
  },
  created () {
    if (this.$route.query.dealer) {
      this.$store.state.form.dealer = {
        dealerId: this.$route.query.dealer
      }
    } else if (this.$route.query.dws) {
      this.dws = true
      this.$store.state.form.dealer = {
        dealerId: this.$route.query.dws
      }
    }
  },
  data () {
    return {
      dws: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Form.vue